<template>
  <div class="singleDisbursementModal">
    <div class="layout-left-right-container">
      <p class="layout-left-container title-14-600">{{ $t('merchantAccount.payment_details') }}</p>
      <p class="layout-right-container title-14-600">{{ $t('merchantAccount.beneficiary_details') }}</p>
    </div>

    <div class="form-container">
      <el-form ref="singleDisbursementForm" :model="singleDisbursementForm" status-icon label-position="left" label-width="200px">
        <div class="layout-left-right-container">
          <div class="layout-left-container">
            <el-form-item
              v-if="$store.getters.curCountry.country_code === 'TH'"
              :label="$t('merchantAccount.beneficiary_account_type')"
              prop="beneficiary_account_type"
              :rules="[
                { required: true, message: 'Beneficiary account type cannot be empty', trigger: 'blur'}
              ]"
            >
              <el-select v-model="singleDisbursementForm.beneficiary_account_type" placeholder="Select beneficiary account type" filterable class="select-item" clearable>
                <el-option
                  v-for="(item,index) in beneficiaryAccountType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  :alt="item.label"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="$store.getters.curCountry.country_code !== 'TH' || singleDisbursementForm.beneficiary_account_type === 'BANK'"
              :label="$t('merchantAccount.recipient_channel')"
              prop="code"
              :rules="[
                { required: true, message: 'Receiving channel cannot be empty', trigger: 'blur'}
              ]"
            >
              <el-select v-model="singleDisbursementForm.code" placeholder="Select receiving channel" filterable class="select-item" clearable @change="disbursementChannelChange">
                <el-option
                  v-for="(item,index) in bankList"
                  :key="index"
                  :label="item.name_with_full_bank"
                  :value="item.bank_code"
                  :alt="item.name_with_full_bank"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="$store.getters.curCountry.country_code === 'TH' && singleDisbursementForm.beneficiary_account_type === 'PROMPTPAY'"
              :label="$t('merchantAccount.beneficiary_type')"
              prop="beneficiary_type"
              :rules="[
                { required: true, message: 'Beneficiary type cannot be empty', trigger: 'blur'}
              ]"
            >
              <el-select v-model="singleDisbursementForm.beneficiary_type" placeholder="Select beneficiary type" filterable class="select-item" clearable @change="disbursementChannelChange">
                <el-option
                  v-for="(item,index) in beneficiaryType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  :alt="item.label"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('merchantAccount.beneficiary_name')"
              prop="account_name"
              :rules="[
                { required: true, message: 'Beneficiary Name cannot be empty', trigger: 'blur'},
                { validator: checkWhitespace, trigger: 'blur'}
              ]"
            >
              <el-input v-model="singleDisbursementForm.account_name" placeholder="Enter beneficiary name" class="search-frame" autocomplete="off" clearable maxlength="40" show-word-limit />
            </el-form-item>

            <el-form-item
              :label="$t('merchantAccount.beneficiary_account_no')"
              prop="account_no"
              :rules="[
                { required: true, message: 'Beneficiary Account No. cannot be empty', trigger: ['blur','change']},
                { validator: checkoutAccountNo, trigger: ['blur','change']}
              ]"
            >
              <el-input v-model="singleDisbursementForm.account_no" placeholder="Enter beneficiary account no." class="search-frame" autocomplete="off" clearable maxlength="50" show-word-limit />
            </el-form-item>
            <el-form-item
              :label="$t('customerService.beneficiary_mobile')"
              prop="mobile"
              :rules="[
                { required: $store.getters.curCountry.country_code === 'ID', message: 'Please input the correct mobile', trigger: ['blur', 'change'] },
                { validator: checkMobile, trigger: ['blur','change'] }
              ]"
            >
              <el-input v-model.trim="singleDisbursementForm.mobile" placeholder="Enter beneficiary mobile" class="search-frame" autocomplete="off" clearable :maxlength="getStandardPaymentLimitMapMobileLength($store.getters.curCountry.country_code)" show-word-limit />
            </el-form-item>
            <el-form-item
              :label="$t('customerService.email_address')"
              prop="email"
              :rules="[
                { type: 'email', message: 'Please input the correct email', trigger: ['blur', 'change'] },
              ]"
            >
              <el-input v-model.trim="singleDisbursementForm.email" placeholder="Enter email address" class="search-frame" autocomplete="off" clearable />
            </el-form-item>
          </div>
          <div class="layout-right-container">
            <!-- 商户订单号 -->
            <el-form-item
              :label="$t('merchantAccount.merchant_order_id')"
              prop="merchant_order_id"
            >
              <el-input
                v-model.trim="singleDisbursementForm.merchant_order_id"
                maxlength="32"
                show-word-limit
                placeholder="Enter merchant order ID"
                type="text"
                class="search-frame"
                autocomplete="off"
                clearable
              />
            </el-form-item>
            <el-form-item
              prop="amount"
              :rules="[
                { required: true, message: 'Amount cannot be empty', trigger: ['blur','change']},
                { validator: checkAmount, trigger: ['blur','change'] }
              ]"
            >
              <template slot="label">
                {{ $t('components.amount') }}
                <el-tooltip placement="top">
                  <div slot="content">
                    <span> {{ amountTips }}</span> <br>
                  </div>
                  <span>  <svg-icon class-name="icon-question" icon-class="help-question" /></span>
                </el-tooltip>
              </template>
              <el-input v-model.trim="singleDisbursementForm.amount" type="text" placeholder="Enter amount" class="search-frame" autocomplete="off" clearable />
            </el-form-item>
            <el-form-item :label="$t('merchantAccount.payment_remark') + ':'">
              <el-input
                v-model="singleDisbursementForm.remark"
                placeholder="Enter your message here"
                type="textarea"
                autocomplete="off"
                maxlength="256"
                show-word-limit
              />
            </el-form-item>
            <el-form-item
              v-if="$store.getters.isOpenMfa"
              :label="$t('system.mfa_verify_code')"
              prop="mfa_code"
              :rules="[{ validator: validateVerifyCode, trigger: ['blur', 'change'] }]"
              required
            >
              <el-input
                v-model="singleDisbursementForm.mfa_code"
                maxlength="6"
                class="input-password"
                placeholder="Enter your MFA verification code"
                autocomplete="off"
                show-word-limit
              />
            </el-form-item>
          </div>
        </div>

      </el-form>
    </div>
    <div class="cp-btn">
      <el-button type="info" plain class="btn-footer" @click="onClickCancelBtn">{{ $t('components.cancel') }}</el-button>
      <el-button class="btn-footer" type="info" :disabled="submiting" @click="onClickSubmitBtn">{{ $t('components.confirm') }}</el-button>
    </div>
  </div>
</template>

<script>
import { addSingleDisbursement, fetchReferenceBatchNo } from '@/api/online-transaction/online-transaction.js'
import { fetchDisbursementAllCodeList } from '@/api/components/components.js'
import { beneficiaryAccountType, beneficiaryType } from '@/utils/maps'
export default {
  name: 'SingleStandardPayoutCreateContent',
  props: {
    balance: {
      type: Number,
      default: 0
    }
  },
  data() {
    this.validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (value.includes(' ')) {
        return callback(new Error('Please do not enter spaces'))
      }
      if (value.length !== 6 || !/^\d+$/.test(value)) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      return callback()
    }
    this.BANK = 1
    this.checkWhitespace = (rule, value, callback) => {
      if (value.trim() !== value) {
        return callback(new Error('Please make sure there are no spaces at the beginning or end of your input.'))
      }
      callback()
    }

    this.checkMobile = (rule, value, callback) => {
      if (this.$store.getters.curCountry.country_code !== 'ID' && !value) {
        return callback()
      }
      if (value !== '0' && !Number(value)) {
        return callback(new Error('Only can input number'))
      }
      switch (this.$store.getters.curCountry.country_code) {
        case 'PH':
          if (!/^09[0-9]{9}$/.test(value)) {
            return callback(new Error('Please enter the 11 numbers starting with 09'))
          }
          break
        case 'TH':
          if (!/^0([689]\d{8})$/.test(value)) {
            return callback(new Error('Please enter the 10 numbers starting with 0, followed by 6, 8, or 9.'))
          }
          break
        case 'ID':
          if (!/^(08[0-9]{8,11})$/.test(value)) {
            return callback(new Error('Please enter the 10-13 numbers starting with 08'))
          }
          break

        default:
          break
      }
      callback()
    }

    this.checkAmount = (rule, value, callback) => {
      value = Number(value)
      //  根据不同国家限额不同设置对应规则
      const standardPaymentLimit = this.standardPaymentLimitMap(this.$store.getters.curCountry.country_code)
      if (standardPaymentLimit && standardPaymentLimit.minAmount && value < standardPaymentLimit.minAmount) {
        return callback(new Error(this.$t('send_pagements.standard_payment_min_amount', { amount: standardPaymentLimit.minLabel })))
      }
      if (standardPaymentLimit && value > standardPaymentLimit.amount) {
        return callback(new Error(`Currently up to ${standardPaymentLimit.label}`))
      }
      this.$commonFn.validateFormAmount({ rule, value, callback })
      if (value > this.$commonFn.mathDivide(this.balance, 100)) {
        return callback(new Error('Insufficient balance!'))
      }
      callback()
    }

    this.checkoutAccountNo = (rule, value, callback) => {
      const bankItem = this.bankList.find(item => item.bank_code === this.singleDisbursementForm.code) || {}
      if (/\s/g.test(value)) {
        return callback(new Error('The input value cannot contain spaces'))
      }
      if (value !== '0' && !Number(value)) {
        return callback(new Error('Only can input number'))
      }
      const { beneficiary_account_type, beneficiary_type } = this.singleDisbursementForm
      if (bankItem.bank_type === 2 || (beneficiary_account_type === 'PROMPTPAY' && beneficiary_type === 'MOBILE_NUMBER')) {
        switch (this.$store.getters.curCountry.country_code) {
          case 'PH':
            if (!/(09)\d{9}$/.test(value)) {
              return callback(new Error('Please input the correct beneficiary account number which start with 09'))
            }
            break
          case 'TH':
            if (beneficiary_account_type === 'PROMPTPAY' && beneficiary_type === 'MOBILE_NUMBER' && !/^0([689]\d{8})$/.test(value)) {
              return callback(new Error('Please enter the 10 numbers starting with 0, followed by 6, 8, or 9.'))
            }
            break
          case 'ID':
            if (!/^(08[0-9]{8,11})$/.test(value)) {
              return callback(new Error('Please input the correct beneficiary account number which start with 08'))
            }
            break

          default:
            break
        }
      }
      if (value.trim() !== value) {
        return callback(new Error('Please make sure there are no spaces at the beginning or end of your input.'))
      }
      if (value.length && value.length < 5) {
        return callback(new Error('Please input between 5 to 50 characters.'))
      }
      callback()
    }
    return {
      bankList: [],
      singleDisbursementForm: {
        beneficiary_account_type: 'BANK',
        account_no: null,
        mfa_code: ''
      },
      submiting: false,
      reference_batch_no: null
    }
  },
  computed: {
    beneficiaryAccountType() {
      return beneficiaryAccountType().filter(item => item.value === 'BANK' || item.value === 'PROMPTPAY')
    },
    beneficiaryType() {
      return beneficiaryType().filter(item => item.value === 'NATIONAL_ID' || item.value === 'MOBILE_NUMBER')
    },
    getStandardPaymentLimitMapMobileLength() {
      return function(value) {
        return this.standardPaymentLimitMap(value).mobileLength
      }
    },
    getStandardPaymentLimitMapLabel() {
      return function(value) {
        return this.standardPaymentLimitMap(value).label
      }
    },
    amountTips() {
      return `${this.$t('tips.standard_payment_limit')} ${this.getStandardPaymentLimitMapLabel(this.$store.getters.curCountry.country_code)} ${this.$store.getters.curCountry.currency}`
    }
  },
  created() {
    this.getAllBank()
  },
  methods: {
    standardPaymentLimitMap(value) {
      const map = {
        PH: {
          value: 'PH',
          label: '50,000',
          mobileLength: 11,
          amount: 50000
        },
        TH: {
          value: 'TH',
          label: '50,000',
          mobileLength: 10,
          amount: 50000
        },
        ID: {
          value: 'ID',
          label: '250,000,000',
          mobileLength: 13,
          amount: 250000000
        },
        VN: {
          value: 'VN',
          label: '200,000,000',
          minLabel: '10,000',
          mobileLength: null,
          amount: 200000000,
          minAmount: 10000
        }
      }
      return map[value]
    },
    initEnterSingleStandardPayoutContent() {
      this.initContent()
      this.getReferenceBatchNo()
    },
    initContent() {
      this.reference_batch_no = null
      this.singleDisbursementForm = {
        beneficiary_account_type: 'BANK',
        account_no: null
      }
      this.$nextTick(function() {
        this.$refs['singleDisbursementForm'].clearValidate()
      })
    },
    getReferenceBatchNo() {
      return fetchReferenceBatchNo().then(res => {
        if (res.code === 10000) {
          this.reference_batch_no = res.data
        }
      })
    },
    clearValidate(formName) {
      this.$nextTick(function() {
        this.$refs[formName].clearValidate()
      })
    },
    getAllBank() {
      fetchDisbursementAllCodeList().then(res => {
        if (res.code === 10000) {
          const list = res.data
          list.map(item => {
            item.name_with_full_bank = item.bank_code
            if (item.bank_type === this.BANK) {
              item.name_with_full_bank = item.bank_code + ' - ' + item.full_name
            }
            return item
          })
          this.bankList = list
        }
      })
    },
    async onClickSubmitBtn() {
      // if (!this.reference_batch_no) {
      await this.getReferenceBatchNo()
      // }
      this.$refs.singleDisbursementForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
            confirmButtonText: this.$t('components.submit'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning'
          }).then(() => {
            this.submiting = true
            const params = { ...this.singleDisbursementForm }
            params.amount = +params.amount
            params.reference_batch_no = this.reference_batch_no
            if (params.account_no) {
              params.account_no = params.account_no.trim()
            }
            if (params.account_name) {
              params.account_name = params.account_name.trim()
            }
            addSingleDisbursement(params).then(res => {
              if (res.code === 10000) {
                this.dialogVisible = false
                this.singleDisbursementForm = {
                  account_no: null
                }
                this.$message.success('Submit SuccessFully')
                this.$emit('closeModal')
                this.$emit('updateList')
              }
            }).finally(() => {
              setTimeout(() => {
                this.submiting = false
              }, 500)
            })
          })
        }
      })
    },
    onClickCancelBtn() {
      this.$emit('closeModal')
      this.$emit('showChooseModal')
    },
    disbursementChannelChange() {
      if (this.singleDisbursementForm.code) {
        this.$nextTick(function() {
          this.$refs['singleDisbursementForm'].clearValidate(['code'])
        })
      }
      this.singleDisbursementForm.account_no = null
      this.$nextTick(function() {
        this.$refs['singleDisbursementForm'].clearValidate(['account_no'])
      })
    }
  }
}
</script>

<style scoped>
.select-item{
  width:100%;
}
.tip{
  font-size: 14px;
  font-weight: 400;
  color: #303133;
}

.cp-btn {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
}
.btn-footer{
  width: 170px;
}
.payout-second-title {
  font-size: 18px;
  color: #000000;
}
.mt-12{
  margin-top: 14px
}
::v-deep .el-form-item__error{
  width: max-content;
}
</style>
